import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import './css/chat.css';
import chat_ca from './img/랑랑이png/02.png';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import {getWelcome} from '../../_actions/chatbot_actions';
import { getUA,isDesktop, BrowserView } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import { Card, message } from 'antd';

function Index() {
	const dispatch = useDispatch();

	const libraryList = 
	[{value:'MA',label:'중랑'}, {value:'MB',label:'면목'},  {value:'ME',label:'양원'},   {value:'MF',label:'상봉'}, {value:'MC',label:'중화'}, 
	{value:'MD',label:'중랑숲'}, {value:'LF',label:'면목2동'}, 
	{value:'LG',label:'면목3,8동'}, {value:'LH',label:'면목4동'}, {value:'LI',label:'면목5동'}, 
	{value:'LJ',label:'면목7동'}, {value:'LK',label:'상봉1동'},{value:'LM',label:'중화1동'}, 
	{value:'LN',label:'중화2동'}, {value:'LO', label:'묵1동'}, {value:'LA',label:'묵2동'}, {value:'LB',label:'망우본동'},
	{value:'LC',label:'망우3동'}, {value:'LD', label:'신내1동'}, {value:'LE',label:'신내2동'}, {value:'LP',label:'나무그늘'},
	{value:'LQ',label:'데시앙'}, {value:'LR', label:'장미'}, {value:'LS',label:'겸재'}, {value:'LW',label:'행복터'},
	{value:'LX',label:'장미마을소망'}, {value:'LT', label:'스마트도서관'}, {value:'LU',label:'송곡여고'}
  ];
	
	const {search} = useLocation();
	const {id} = queryString.parse(search);
	
	let manageCode = '';
	let library = '';

	if(!id) {
	manageCode= 'MA'
	library = '중랑'
	}

	let userBrowerEnv = '';

	if(BrowserView) {
		userBrowerEnv = 'BrowserView';
	}
	if (isDesktop) {
		userBrowerEnv = 'isDesktop';
	  }
	
	  if (getUA.match(/NAVER|KAKAOTALK|FBAN|FBAV|Line|Instagram|wadiz|kakaostory|band|twitter|DaumApps/i)) {
		userBrowerEnv = 'INAPP';
	  }


	  console.log('userBrowerEnv', userBrowerEnv);
	  message.info('userBrowerEnv' , userBrowerEnv)

	libraryList.forEach(element => {
		if(element.value === id) {
			manageCode = element.value 
			library    =  element.label
		}
	  })

	  const closeWindow = () => {
		window.close();
	   }

	const linkSetId = `/chatbot?id=${manageCode}`;

	async function welcome (library) {
		// console.log('library' , library);
		return await dispatch(getWelcome(library)); 
	} 

	const userAgent = window.navigator.userAgent


	useEffect(() => {
		welcome(library)
	})
	

	const top = (
		<div className="top">
			<span className="hole">
				<i />
				<i />
				<i />
			</span>
			<span className="btns">
				{/* <button className="btn-q">?</button> */}
				<button className="btn-x" onClick={closeWindow}>
					<i>닫기</i>
				</button>
			</span>
		</div>
	);

	const chatHi = (
		<div className="chat-hi">
			{/* <div className="buble">
				<Texty delay={100}>안녕하세요.</Texty><em><Texty delay={400}>중랑구 공공도서관</Texty></em>{library}<Texty delay={700}>챗봇 입니다.</Texty>
				<Texty delay={1200}>무엇을 도와드릴까요?</Texty>
			</div> */}
			<button className="btn-start">
				<Link to={linkSetId}>채팅시작</Link>
			</button>
			<p className="txt">평균 응답 시간 10분 이내</p>
			<img src={chat_ca} alt="챗봇 캐릭터" />
		</div>
	);

	return (
		<div>
			<div className="chatbot">
				{chatHi}
			</div>
		</div>
	);
}
export default Index;
